export const teamManagement = {
  forbidden: {
    title: "Acesso restrito",
    desc: "Apenas o anfitrião principal pode gerenciar a equipe.",
  },
  header: {
    title: "Gestão da equipe",
    subtitle: "Gerencie quem pode acessar o painel da sua propriedade",
    addMember: "Adicionar membro",
  },
  stats: {
    totalTeam: "Equipe total",
    host: "Anfitrião",
    additionalMembers: "Membros adicionais",
  },
  search: {
    placeholder: "Buscar por nome ou e-mail…",
  },
  loading: "Carregando equipe…",
  table: {
    member: "Membro",
    email: "E-mail",
    role: "Função",
    properties: "Propriedades",
    added: "Adicionado",
    actions: "Ações",
    ownerBadge: "Anfitrião",
    mainHost: "Anfitrião principal",
    viewPermissions: "Ver funcionalidades permitidas",
    allProperties: "Todas",
    unassigned: "Não atribuído",
    notEditable: "Não editável",
    edit: "Editar",
    delete: "Excluir",
  },
  surfaces: {
    web: "Web",
    app: "App",
  },
  empty: {
    title: "Nenhum membro adicional",
    desc: "Use o botão <strong>Adicionar membro</strong> para convidar pessoas para sua equipe.",
  },
  infoBanner:
    "Os membros da equipe acessam o painel com seu próprio usuário e senha. Cada perfil tem permissões fixas e o acesso aos dados é validado no servidor. O proprietário entra somente pela web; limpeza e manutenção, somente pelo app. O <strong>anfitrião principal</strong> sempre tem acesso total e não pode ser removido.",
  modal: {
    createTitle: "Adicionar membro",
    editTitle: "Editar membro",
    nameLabel: "Nome completo",
    namePlaceholder: "ex.: Maria Garcia",
    emailLabel: "Endereço de e-mail",
    emailPlaceholder: "email@example.com",
    roleLabel: "Perfil de acesso",
    viewScope: "Escopo de visualização",
    accessIncluded: "Acesso incluído",
    assignedProperties: "Propriedades atribuídas",
    selectedCount: "({selected} de {total} selecionadas)",
    propertySearchPlaceholder: "Buscar propriedade…",
    selectAll: "Selecionar todas",
    clear: "Limpar",
    noResults: 'Nenhum resultado para "{query}"',
    selectAtLeastOneHint: "Selecione pelo menos uma propriedade para este perfil.",
    noPropertiesWarning:
      "Não há propriedades disponíveis para atribuir. Crie uma propriedade antes de salvar este perfil.",
    passwordLabel: "Senha",
    passwordOptional: "(deixe em branco para manter)",
    passwordPlaceholder: "Pelo menos 8 caracteres",
    confirmPasswordLabel: "Confirmar senha",
    confirmPasswordPlaceholder: "Repita a senha",
    showPassword: "Mostrar senha",
    hidePassword: "Ocultar senha",
    cancel: "Cancelar",
    create: "Criar membro",
    save: "Salvar alterações",
  },
  deleteModal: {
    title: "Excluir membro",
    subtitle: "Esta ação não pode ser desfeita",
    confirm:
      "Tem certeza de que deseja remover {name} da equipe? Ele perderá o acesso ao painel imediatamente.",
    cancel: "Cancelar",
    delete: "Excluir",
  },
  roleInfo: {
    defaultTitle: "Permissões",
    description:
      "Este perfil é fixo. Seu escopo, superfície de acesso e propriedades também são validados no servidor.",
    understood: "Entendi",
  },
  roleDescriptions: {
    anfitrion: "Acesso total a todas as propriedades pela web e pelo app.",
    propietario:
      "Calendários e análises apenas das propriedades atribuídas. Acesso pela web.",
    limpieza:
      "Iniciar limpeza, tarefas e mensagens das suas propriedades. Somente pelo app.",
    mantenimiento:
      "Iniciar manutenção, tarefas e mensagens das suas propriedades. Somente pelo app.",
    fallback: "Perfil de compatibilidade com acesso restrito.",
  },
  optionalHints: {
    messages:
      "Ver e responder às conversas das suas propriedades. Se desativado, ele não verá mensagens nem receberá as notificações.",
  },
  toasts: {
    loadError: "Não foi possível carregar a equipe.",
    memberAdded: "✓ Membro adicionado à equipe.",
    memberUpdated: "✓ Membro atualizado.",
    saveError: "Não foi possível salvar. Tente novamente.",
    memberDeleted: "Membro removido da equipe.",
    deleteError: "Não foi possível remover o membro.",
  },
};
